import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import {
  NgxIntlTelInputModule,
  SearchCountryField,
  CountryISO,
} from 'ngx-intl-tel-input';
import { TranslateModule } from '@ngx-translate/core';
import { SelectComponent } from 'app/shared/components/select/select.component';
import { PhoneInputDirective } from 'app/shared/directives/phone-input.directive';
import {
  Nationality,
  Occupation,
  Country,
  State,
  City,
} from 'app/core/models/patient/patient.model';
import {
  Organization,
  Facility,
} from 'app/core/models/organization/organization.model';

@Component({
  selector: 'app-patient-personal-info-step',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    TranslateModule,
    SelectComponent,
    PhoneInputDirective,
  ],
  templateUrl: './patient-personal-info-step.component.html',
  styleUrl: './patient-personal-info-step.component.scss',
})
export class PatientPersonalInfoStepComponent implements OnInit {
  @Input() patientForm!: FormGroup;
  @Input() nationalities: Nationality[] = [];
  @Input() occupations: Occupation[] = [];
  @Input() genders: Array<{ id: number; name: string }> = [];
  @Input() maritalStatuses: Array<{ id: number; name: string }> = [];
  @Input() countries: Country[] = [];
  @Input() cities: State[] = [];
  @Input() districts: City[] = [];
  @Input() organizations: Organization[] = [];
  @Input() facilities: Facility[] = [];
  @Input() isSystemAdmin: boolean = false;
  @Input() todayDate: string = '';
  @Input() defaultPatientCountry: CountryISO = CountryISO.Turkey;
  @Input() defaultEmergencyContactCountry: CountryISO = CountryISO.Turkey;

  @Output() countryChange = new EventEmitter<number>();
  @Output() cityChange = new EventEmitter<number>();
  @Output() organizationChange = new EventEmitter<string>();
  @Output() dateInput = new EventEmitter<Event>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() checkExistence = new EventEmitter<void>();

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;

  ngOnInit(): void {}

  onCountryChange(countryId: number): void {
    this.countryChange.emit(countryId);
  }

  onCityChange(cityId: number): void {
    this.cityChange.emit(cityId);
  }

  onOrganizationChange(orgId: string): void {
    this.organizationChange.emit(orgId);
  }

  onDateInput(event: Event): void {
    this.dateInput.emit(event);
  }

  onPidBlur(): void {
    this.checkExistence.emit();
  }

  onSubmit(): void {
    if (this.patientForm.valid) {
      this.nextStep.emit();
    } else {
      this.patientForm.markAllAsTouched();
    }
  }
}
